<!-- REV-22155: mandate management of a person project — same building blocks as cpmm/mandate-management -->
<app-aumico-layout [hideFooter]="true">
    <ng-container header>
        <ham-page-header data-testid="person-mandate-title" [title]="title" [backButtonRoute]="backRoute"></ham-page-header>
        <!-- One tab, as on the company page (there: Mandatsverwaltung / Abschluss-Workflow / Bericht) -->
        <ham-page-tab-navigation [navigationItems]="navigationTabs"></ham-page-tab-navigation>
    </ng-container>
    <ng-container content>
        <div class="person-mandate-management" data-testid="person-mandate-management">
            <app-sync-banner
                data-testid="mm-sync-hint"
                *ngIf="isSyncNeeded"
                [workflowArea]="WorkflowArea.MANDATE_MANAGEMENT"
                (dismiss)="onDismiss()"
                (sync)="onSync()"
            ></app-sync-banner>
            <workflow-form
                *ngIf="tasks$ | async as tasks"
                [documentExpirationDate]="documentExpirationDate"
                [tasks]="tasks"
                [area]="WorkflowArea.MANDATE_MANAGEMENT"
                [assigneeOptions]="assigneeOptions"
                [deletedUsers]="deletedUsers"
                (updateTask)="updateTask($event)"
                (bulkUpdateTasks)="bulkUpdateTasks($event)"
                (addTask)="addNewTask($event)"
                (deleteTask)="deleteTask($event)"
                [annotationsMap]="annotationsMap"
                [documentsMap]="documentsMap"
                [currentUserId]="activeUserAumicoInternalId"
                [projectId]="projectId"
                (exportZip)="exportZip()"
                (exportExcel)="exportTasksExcel($event)"
                (annotationAdded)="onAnnotationAdded($event)"
                (annotationChanged)="onAnnotationChanged($event)"
                (annotationRemoved)="onAnnotationRemoved($event)"
                (documentsAdded)="onDocumentsAdded($event)"
                (documentsAddedInProgress)="onDocumentsAddedInProgress($event)"
                (documentRemoved)="onDocumentRemoved($event)"
                (syncWorkflow)="onSync()"
                [documentsInProgressUpload]="documentsInProgressUpload"
                (openFile)="onOpenFile($event)"
                (downloadFile)="onDownloadFile($event.fileId, $event.documentName)"
                (stopPolling)="onStopPolling($event)"
                (startPolling)="onStartPolling($event)"
                [selectAll]="selectAll"
                [sectionToggled]="sectionToggled"
                [selectedTaskIds]="selectedTaskIds"
                (toggleSelectAll)="toggleCheckAll($event)"
                (toggleSelectSection)="toggleSectionSelectAll($event)"
                (toggleSelectTask)="toggleCheckTask($event)"
            ></workflow-form>
            <app-loading-spinner [active]="isSyncingWorkflow"></app-loading-spinner>
            <!-- Bulk Edit action bar -->
            <bulk-edit-action-bar
                *ngIf="selectedTaskIds?.size > 0"
                [selectedCount]="selectedTaskIds?.size"
                [actions]="bulkActions"
                [deleteAction]="deleteAction"
                textSelectedTranslationKey="aumico_companies_bulk_edit_action_bar_selected_text"
                [globalPosition]="true"
                (actionClicked)="onActionClicked($event)"
            ></bulk-edit-action-bar>

            <!-- Ham Modal for Bulk Edit Status -->
            <ham-modal
                *ngIf="openBulkEditStatus"
                [title]="'aumico_tasks_overview_bulk_edit_status_title' | i18next : { count: selectedTaskIds.size }"
                [cancelText]="'aumico_button_cancel' | i18next"
                [showCancelButton]="true"
                (cancel)="openBulkEditStatus = false"
                [saveText]="'aumico_button_save' | i18next"
                (save)="onEditStatusConfirm()"
                ><input
                    hamSimpleDropDown
                    [label]="'aumico_tasks_overview_bulk_edit_status_label' | i18next"
                    [options]="possibleStatus"
                    [optionKeys]="['name']"
                    returnKey="id"
                    [returnObject]="true"
                    [placeholder]="'aumico_tasks_overview_bulk_edit_status_placeholder' | i18next"
                    [formControl]="bulkEditStatusControl"
            /></ham-modal>

            <!-- Ham Modal for Assignee Change -->
            <ham-modal
                *ngIf="openBulkEditAssignee"
                [title]="'aumico_tasks_overview_bulk_edit_assignee_title' | i18next : { count: selectedTaskIds.size }"
                [cancelText]="'aumico_button_cancel' | i18next"
                [showCancelButton]="true"
                (cancel)="openBulkEditAssignee = false"
                [saveText]="'aumico_button_save' | i18next"
                (save)="onEditAssigneeConfirm()"
                ><input
                    hamSimpleDropDown
                    [label]="'aumico_tasks_overview_bulk_edit_assignee_label' | i18next"
                    [options]="assigneeOptions"
                    [optionKeys]="['name']"
                    returnKey="id"
                    [returnObject]="true"
                    [placeholder]="'aumico_tasks_overview_bulk_edit_assignee_placeholder' | i18next"
                    [formControl]="bulkEditAssigneeControl"
            /></ham-modal>

            <!-- HamModal for Due Date Change -->
            <ham-modal
                *ngIf="openBulkEditDueDate"
                [title]="'aumico_tasks_overview_bulk_edit_due_date_title' | i18next : { count: selectedTaskIds.size }"
                [cancelText]="'aumico_button_cancel' | i18next"
                [showCancelButton]="true"
                (cancel)="openBulkEditDueDate = false"
                [saveText]="'aumico_button_save' | i18next"
                (save)="onEditDueDateConfirm()"
                [size]="'xs'"
            >
                <div class="custom-datepicker-wrapper">
                    <mat-calendar
                        [selected]="bulkEditDueDateControl.value"
                        (selectedChange)="bulkEditDueDate($event)"
                    ></mat-calendar></div
            ></ham-modal>

            <!-- HamModal for Bulk Delete -->
            <ham-confirm-decline-modal
                *ngIf="openBulkDeleteConfirmationDialog"
                (cancel)="cancelDeleteBulkTasks()"
                (action)="confirmDeleteBulkTasks()"
                footerAlignment="center"
                actionBtnText="{{ 'aumico_button_delete' | i18next }}"
                noActionBtnText="{{ 'aumico_button_cancel' | i18next }}"
            >
                <ham-general-confirm-decline-modal-body
                    [text]="'aumico_app_cpmm_tasks_delete_confirmation' | i18next : { count: selectedTaskIds.size }"
                ></ham-general-confirm-decline-modal-body>
            </ham-confirm-decline-modal>
        </div>
    </ng-container>
</app-aumico-layout>
